import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Header2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { getAllDiscussions } from "~/store/selectors/selector.discussions";
import { getAllNotes } from "~/store/selectors/selector.notes";
import { getRemindersByDate } from "~/store/selectors/selector.reminders";
import { getAllTasks } from "~/store/selectors/selector.tasks";
import { CalendarReminderItem } from "./CalendarReminderItem";

export const CalendarReminders = ({ date }) => {
  const { t } = useTranslation();
  const remindersByDate = useSelector((state) => getRemindersByDate(state, date));

  const tasks = useSelector(getAllTasks);
  const notes = useSelector(getAllNotes);
  const discussions = useSelector(getAllDiscussions);

  const reminders = useMemo(() => {
    if (remindersByDate) {
      return remindersByDate
        .reduce((prev, next) => {
          let parent;
          if (next.parent_type === "Task") {
            parent = tasks.get(`${next.parent_id}`)?.toJS();
          }
          if (next.parent_type === "Note") {
            parent = notes[next.parent_id];
          }
          if (next.parent_type === "Discussion") {
            parent = discussions[next.parent_id];
          }

          if (parent) {
            prev.push({ ...next, parent: parent });
          }

          return prev;
        }, [])
        .sort((a, b) => a.parent.name.localeCompare(b.parent.name));
    }
    return [];
  }, [discussions, notes, remindersByDate, tasks]);

  if (remindersByDate.length === 0) {
    return null;
  }
  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-flex tw-items-center tw-h-10">
        <Header2>{t("Reminders")}</Header2>
      </div>
      {reminders.map((reminder, index) => {
        return (
          <div
            className="tw-flex tw-justify-between tw-w-full"
            key={index}
          >
            <CalendarReminderItem
              parent={reminder.parent}
              subscribers={reminder.subscribers}
            />
          </div>
        );
      })}
    </div>
  );
};
CalendarReminders.propTypes = {
  date: PropTypes.string,
};
